"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function WhyChooseUs() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const imageRef = useRef<HTMLDivElement>(null);
  const [parallaxOffset, setParallaxOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        const scrollProgress = Math.max(0, Math.min(1, 1 - rect.top / window.innerHeight));
        setParallaxOffset(scrollProgress * 8);
      }
    };
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!mediaQuery.matches) {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  const differentiators = [{
    title: "Hands-On Project Management",
    description: "Tailored solutions that streamline your operations and keep projects on track."
  }, {
    title: "Specialized Film Development",
    description: "Expert packaging services connecting creators with funding sources and industry relationships."
  }, {
    title: "Clear, Organized Workflows",
    description: "Structured processes that save time, enhance credibility, and drive measurable results."
  }];
  return <section className="bg-dark-background text-foreground-dark py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className="space-y-8">
            <h2 className="font-display text-3xl md:text-4xl font-semibold mb-8">
              Why Choose Us
            </h2>

            {}
            <div ref={section1Ref} className={`group cursor-default ${section1Visible ? "animate-fade-in-up" : "opacity-0"}`}>
              <h3 className="font-display text-xl font-semibold mb-2 inline-block border-b-2 border-transparent group-hover:border-foreground-dark transition-all duration-[var(--duration-medium)]">
                {differentiators[0].title}
              </h3>
              <p className="text-foreground-dark/80 leading-relaxed">
                {differentiators[0].description}
              </p>
            </div>

            {}
            <div ref={section2Ref} className={`group cursor-default ${section2Visible ? "animate-fade-in-up-delay-100" : "opacity-0"}`}>
              <h3 className="font-display text-xl font-semibold mb-2 inline-block border-b-2 border-transparent group-hover:border-foreground-dark transition-all duration-[var(--duration-medium)]">
                {differentiators[1].title}
              </h3>
              <p className="text-foreground-dark/80 leading-relaxed">
                {differentiators[1].description}
              </p>
            </div>

            {}
            <div ref={section3Ref} className={`group cursor-default ${section3Visible ? "animate-fade-in-up-delay-200" : "opacity-0"}`}>
              <h3 className="font-display text-xl font-semibold mb-2 inline-block border-b-2 border-transparent group-hover:border-foreground-dark transition-all duration-[var(--duration-medium)]">
                {differentiators[2].title}
              </h3>
              <p className="text-foreground-dark/80 leading-relaxed">
                {differentiators[2].description}
              </p>
            </div>
          </div>

          {}
          <div ref={imageRef} className="relative h-[400px] md:h-[500px] lg:h-[600px] rounded-lg overflow-hidden shadow-strong" style={{
          transform: `translateY(${parallaxOffset}px)`,
          transition: "transform 0.1s linear"
        }}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1517061/img/why_choose_us_professional_team.png" alt="Freedom Productions team collaborating on project" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </section>;
}